import { render } from "./DirectReport.vue?vue&type=template&id=cb1dddd6"
import script from "./DirectReport.vue?vue&type=script&lang=js"
export * from "./DirectReport.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__